module.exports = __webpack_public_path__ + "img/heart_copyright.fe05bc7e.svg";